<script>

import { colorList } from '@/model/dataLayer/api/Vip/VipCommon'

export default {
  name: 'DisplayInfoTitleShow',
  data: function () {
    return {
      colorList,
      fileStore: null
    }
  },
  props: {
    info: {
      type: Object,
      default: () => {
        return {
          name: '',
          description: '',
          color: '#eeeeee',
          imageUrl: ''
        }
      }
    }
  }
}
</script>

<template>
  <div
    class="d-flex flex-column"
  >
    <div
      class="d-flex flex-column align-center"
    >
      <div class="d-flex align-center">
        <v-avatar
          v-if="info.imageUrl"
          class="mr-3"
          size="40"
        >
          <v-img
            :src="info.imageUrl"
            alt="Voucher Type Image"
          />
        </v-avatar>
        <div>
          <h2 class="text-h5 mb-1">
            {{ info.name }}
          </h2>
          <p
            v-if="info.description"
            class="text-body-2 mb-0"
          >
            {{ info.description }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
